// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S6Ne","badges":"styles_badges__btdLX"};